<script setup>
  const props = defineProps({
    imported: { default: false, type: Boolean },
    isCareerSite: { default: false, type: Boolean },
    cover: { type: Object },
    employer: { required: true, type: Object },
    title: { required: true, type: String }
  })
  const cover = ref(props.cover ?? props.employer.cover)
</script>

<template>
  <header
    :class="[
      'absolute inset-x-0 z-10 h-32 overflow-x-hidden bg-cover bg-center lg:fixed lg:h-40',
      isCareerSite ? 'top-0' : 'top-16 md:max-lg:top-20',
      imported ? 'bg-tarawera-950' : ''
    ]"
    :style="{
      backgroundImage: !imported && cover?.url ? `url('${useStrapiMedia(cover.url)}')` : undefined
    }"
  >
    <div :class="['h-full max-sm:py-3', !imported && 'bg-black/50']">
      <div class="mx-auto flex h-full items-center justify-center px-4 text-center max-sm:flex-col sm:space-x-6 lg:space-x-8">
        <NuxtLink class="max-sm:order-2" :to="employer.website">
          <NuxtImg
            class="w-10 rounded-full hover:cursor-pointer sm:w-16 lg:w-20"
            v-if="employer.logo?.url"
            :src="useStrapiMedia(employer.logo.url)"
            alt="employer.name"
          />
        </NuxtLink>
        <div class="text-white max-sm:order-1 max-sm:mb-2">
          <h1 class="line-clamp-2 text-lg font-bold leading-normal max-sm:mb-2 sm:line-clamp-3 sm:text-xl md:text-2xl lg:text-3xl">
            {{ title }}
          </h1>
          <div :class="[' lg:text-xl', !isCareerSite && 'font-main']">
            {{ employer.name }}
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
